import { render } from "./taskEdit.vue?vue&type=template&id=12b06e16&scoped=true"
import script from "./taskEdit.vue?vue&type=script&lang=js"
export * from "./taskEdit.vue?vue&type=script&lang=js"

import "./taskEdit.vue?vue&type=style&index=0&id=12b06e16&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b06e16"]])

export default __exports__